import api from './api';

/**
 * Request password reset via email
 * @param {string} email - User or association email
 * @returns {Promise<Object>} - Result message
 */
export const requestPasswordReset = async (email) => {
  try {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || 'Errore durante la richiesta di reset password.';
  }
};

/**
 * Reset password with token
 * @param {string} token - Reset token received via email
 * @param {string} password - New password
 * @returns {Promise<Object>} - Result message
 */
export const resetPassword = async (token, password) => {
  try {
    const response = await api.post('/auth/reset-password', { token, password });
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || 'Errore durante il reset della password.';
  }
};
